import { useCallback, useEffect, useMemo, useState } from 'react';
import constate from '../../common/lib/constate';
import useWindowSize from '../hooks/useWindowSize';

function useUI() {
  const [miniSidebar, setMiniSidebar] = useState(false);
  const toggleMiniSidebar = useCallback(state => {
    if (typeof state === 'boolean') setMiniSidebar(state);
    else setMiniSidebar(prevState => !prevState);
  }, []);

  const [mobileSidebar, setMobileSidebar] = useState(false);
  const toggleMobileSidebar = useCallback(state => {
    if (typeof state === 'boolean') setMobileSidebar(state);
    else setMobileSidebar(prevState => !prevState);
  }, []);

  const [miniSettingLinks, setMiniSettingLinks] = useState(false);
  const toggleMiniSettingLinks = useCallback(state => {
    if (typeof state === 'boolean') setMiniSettingLinks(state);
    else setMiniSettingLinks(prevState => !prevState);
  }, []);

  const mediaMatch = window.matchMedia('(max-width: 900px)');
  const [isMobileView, setIsMobileView] = useState(mediaMatch.matches);

  const { width } = useWindowSize();

  const [forcedPlayerStyles, setForcedPlayerStyles] = useState({});
  const changeForcedPlayerStyles = useCallback(styles => {
    setForcedPlayerStyles(styles);
  }, []);

  const [forcedMinSlider, setForcedMinSlider] = useState(false);

  const forceMinSlider = useCallback(value => {
    setForcedMinSlider(value);
  }, []);

  useEffect(() => {
    const mediaMatch = window.matchMedia('(max-width: 900px)');
    setIsMobileView(mediaMatch.matches);
  }, [width]);

  return useMemo(
    () => ({
      miniSidebar,
      toggleMiniSidebar,
      miniSettingLinks,
      toggleMiniSettingLinks,
      mobileSidebar,
      toggleMobileSidebar,
      isMobileView,
      forcedPlayerStyles,
      changeForcedPlayerStyles,
      forceMinSlider,
      forcedMinSlider,
      forceMinSlider,
    }),
    [
      miniSidebar,
      toggleMiniSidebar,
      miniSettingLinks,
      toggleMiniSettingLinks,
      mobileSidebar,
      toggleMobileSidebar,
      forcedPlayerStyles,
      changeForcedPlayerStyles,
      forcedMinSlider,
      forceMinSlider,
    ]
  );
}

export const useUIContext = constate(useUI);

const UIContext = {
  Provider: useUIContext.Provider,
};

export default UIContext;
